// CustomerRow.jsx
import React, { useState } from 'react';
import Classes from './Table.module.css';

import DropDown from './StatusDropDown/DropDown';

export default function TableRow({ value, index }) {

  return (
    <>
      {/* Desktop view */}
      <div
        className={`${Classes.customerRow} ${value.status === 'disabled' ? Classes.disabledRow : ''
          }`}
        key={value._id}
      >
        <div className={`${Classes.customerInfo} ${Classes.colCustomer}`}>
          <h5>{value.order}</h5>
        </div>
        <div className={`${Classes.spendings} ${Classes.colSpendings}`}>
          <h5>{value.person}</h5>
        </div>
        <div className={`${Classes.bookings} ${Classes.colBookings}`}>
          <DropDown
            selectedValue={value.status}
            options={["Pending", "Submitted", "Working", "Completed", "Canceled"]}
            onChange={(val) => value.status = val}
            isDropDown={false}
          />
        </div>
        <div className={`${Classes.dateJoined} ${Classes.colDate}`}>
          <h5>{value.created}</h5>
        </div>
      </div>
    </>
  );
}
